/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ADD_BUILTIN_POLICY = 'Add Built-in Policy';
export const ADD_BUILTIN_POLICIES = 'Add Built-in Policies';
export const SEARCH = 'Search';
export const LABEL = {
  NAME: 'Name',
  DESCRIPTION: 'Description',
  RULE: 'Rule'
};
export const DELETE = 'delete';
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const DELETE_SUCCESS_MESSAGE = '{0} has been deleted';
